import React, { Component, createContext } from 'react';
import constants from '../config';

const GameContext = createContext({
  games: [],
  currentGame: null,
  gameLoading: true,
  isMultiGame: false,
  setCurrentGame: () => {},
});

class GameProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      games: [],
      currentGame: null,
      gameLoading: true,
    };
    this.setCurrentGame = this.setCurrentGame.bind(this);
  }

  componentDidMount() {
    this.fetchGames();
    this._handleGamesChanged = function() { this.fetchGames(); }.bind(this);
    window.addEventListener('gamesChanged', this._handleGamesChanged);
  }

  componentWillUnmount() {
    window.removeEventListener('gamesChanged', this._handleGamesChanged);
  }

  fetchGames() {
    fetch(constants.DOMAIN + '/api/v1/guest/games', { mode: 'cors', method: 'GET' })
      .then(function(res) { return res.json(); })
      .then(function(data) {
        var games = data.games || [];
        if (games.length === 1) {
          // Single game — auto-fetch full config
          this.fetchGameConfig(games[0].slug, games);
        } else {
          this.setState({ games: games, gameLoading: false });
        }
      }.bind(this))
      .catch(function() {
        this.setState({ gameLoading: false });
      }.bind(this));
  }

  fetchGameConfig(slug, games) {
    // Dedupe in-flight requests — consumers may re-request the same slug
    // on every update until the config lands
    if (this._fetchingSlug === slug) return;
    this._fetchingSlug = slug;
    fetch(constants.DOMAIN + '/api/v1/guest/games/' + slug, { mode: 'cors', method: 'GET' })
      .then(function(res) { return res.json(); })
      .then(function(data) {
        this._fetchingSlug = null;
        if (data && data._id) {
          this.setState({
            games: games || this.state.games,
            currentGame: data,
            gameLoading: false,
          });
        } else {
          this.setState({ games: games || this.state.games, gameLoading: false });
        }
      }.bind(this))
      .catch(function() {
        this._fetchingSlug = null;
        this.setState({ games: games || this.state.games, gameLoading: false });
      }.bind(this));
  }

  setCurrentGame(game) {
    if (game && game.slug && (!this.state.currentGame || this.state.currentGame.slug !== game.slug)) {
      this.fetchGameConfig(game.slug);
    } else if (!game) {
      this.setState({ currentGame: null });
    }
  }

  render() {
    var isMultiGame = this.state.games.length > 1;
    return (
      <GameContext.Provider value={{
        games: this.state.games,
        currentGame: this.state.currentGame,
        gameLoading: this.state.gameLoading,
        isMultiGame: isMultiGame,
        setCurrentGame: this.setCurrentGame,
      }}>
        {this.props.children}
      </GameContext.Provider>
    );
  }
}

export { GameContext, GameProvider };
export default GameContext;
